export type ColorScheme = Record<
  string,
  {
    contrast?: number;
    main?: string;
    text?: string;
  }
>;

export default abstract class ImageWebsiteLogo {
  /**
   * Get the source of the image
   */
  abstract getImageSrc(): string;

  /**
   * Get the alt text of the image
   */
  abstract getAltText(): string;

  /**
   * Get the url of the file whith will be saved in the session and send to the backend later
   */
  abstract getFileUrl(): string;

  /**
   * Get the id of the image
   */
  abstract getId(): string;

  /**
   * Get the colors of the image
   */
  abstract getColors(): ColorScheme | null;

  /**
   * Get the dimensions of the image
   */
  abstract getDimensions(): {
    width: number;
    height: number;
  };
}
